<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="姓名" prop="name"  >
        <a-input v-model="form.name" placeholder="请输入姓名"  :disabled="formTitle == '详情'"/>
      </a-form-model-item>
      <a-form-model-item label="机构公司名称" prop="company" >
        <a-input v-model="form.company" placeholder="请输入机构公司名称"  :disabled="formTitle == '详情'"/>
      </a-form-model-item>
      <a-form-model-item label="所在位置" prop="address" >
        <a-input v-model="form.address" placeholder="请输入所在位置"  :disabled="formTitle == '详情'"/>
      </a-form-model-item>
      <a-form-model-item label="手机号" prop="phone" >
        <a-input v-model="form.phone" placeholder="请输入手机号"  :disabled="formTitle == '详情'"/>
      </a-form-model-item>
      <a-form-model-item label="性别" prop="sex" >
        <a-radio-group name="radioGroup" :default-value="0" v-model="form.sex" :disabled="formTitle == '详情'">
          <a-radio value="0">保密</a-radio>
          <a-radio value="1">男</a-radio>
          <a-radio value="2">女</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear  :disabled="formTitle == '详情'"/>
      </a-form-model-item>
      <div class="bottom-control"  v-if="formTitle!=='详情'">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCooperate, addCooperate, updateCooperate } from '@/api/cooperate/cooperate'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id:  "",

        name:  "",

        company:  "",

        address:  "",

        phone:  "",

        sex: "",

        createTime:  "",

        remark:  "",

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          { required: true, message: '姓名不能为空', trigger: 'blur' }
        ],
        company: [
          { required: true, message: '机构公司名称不能为空', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '所在位置不能为空', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '手机号不能为空', trigger: 'blur' }
        ],
        sex: [
          { required: true, message: '性别,0-保密 1-男 2-女不能为空', trigger: 'change' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id:  "",
        name: "",
        company:  "",
        address:  "",
        phone:  "",
        sex: "0",
        createTime:  "",
        remark:  "",
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleInfo(row, ids) {
      this.reset()
      this.open = true
        this.formTitle = '详情'
      this.formType = 2
      const id = row ? row.id : ids

      getCooperate({id:id}).then(response => {
        this.form = response.data

          this.form.sex= this.form.sex.toString()
        
          console.log(this.form,"this.form")
        })
      
     
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateCooperate(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCooperate(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
